export const MESSAGE_SET_LANGUAGE = 'SET_LANGUAGE';

export const setLang = (lang) => {
    return {
        type: MESSAGE_SET_LANGUAGE,
        lang,
    };
};

